import { render, staticRenderFns } from "./CollectionInformation.vue?vue&type=template&id=992d00b0&"
import script from "./CollectionInformation.vue?vue&type=script&lang=js&"
export * from "./CollectionInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports